export default __webpack_public_path__ + "static/media/download1.42822e5d.webp";